import React from 'react';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import messages from "./messages";

export const IdleTimeOutModal = ({showModal, handleClose, remainingTime}) => {
    const {idleTimeOutHeader, idleTimeOutText, idleTimeLeft} = messages;

    return (
        <Dialog
        open={showModal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id={idleTimeOutHeader.id}>{idleTimeOutHeader.defaultMessage}</DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-description">
                <div id={idleTimeOutText.id}>{idleTimeOutText.defaultMessage}</div>
                <div id={idleTimeLeft.id}>{idleTimeLeft.getText(remainingTime)} </div>
            </DialogContentText>
        </DialogContent>
    </Dialog>
    );
}